import React from 'react'
import FormInput from '../../../library/form/components/FormInput';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvCashCreditBreakupRow = (props) => {
    const { formObject, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn150 uiLbl">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "cstType" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormInput formObject={formObject} rowKey={rowKey} style={{ width: "98%" }} placeholder="Enter value"
                        action={{ InputType: "input", paramName: "cost", actionId: "refresh", actionParam: { updatebreakuptotal: 1, isCashCredit:1 } }}
                    />
                </li>
            </ul>
        )
}

export default InvCashCreditBreakupRow